export default __webpack_public_path__ + "static/media/ios-crome.165167fe.png";